// Re-exports the generated @hey-api client, configured with the API base URL.
// `pnpm openapi:generate` (re)creates src/api/generated/ from the spec published
// by prod-battle-api as an npm package.
//
// Until the first `openapi:generate` runs, this file has no named re-exports.
// Consumers should import from `~/api/generated/sdk.gen` etc. directly once generated.

import { env } from '~/lib/env';

export const API_BASE_URL = env.VITE_API_URL;
